export default __webpack_public_path__ + "static/media/GMX.5bf18adc.svg";